import React from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';

import { useBodyScrollLock } from '@/hooks';

interface SportsSimpleListModalOption {
  id: string;
  label: string;
  icon: string;
}

interface SportsSimpleListModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  titleIcon: string;
  options: SportsSimpleListModalOption[];
  onOptionClick: (opt: string) => void;
}

export const SportsSimpleListModal = ({
  open,
  onClose,
  title,
  titleIcon,
  options,
  onOptionClick,
}: SportsSimpleListModalProps) => {
  useBodyScrollLock(open);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, pb: 1 }}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: '8px',
            bgcolor: 'action.hover',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1.25rem',
          }}
        >
          {titleIcon}
        </Box>
        <Typography variant="h6" fontWeight="bold">
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <List>
          {options.map((opt, index) => (
            <ListItem key={opt.id} disablePadding sx={{ mb: index < options.length - 1 ? 1 : 0 }}>
              <ListItemButton
                onClick={() => onOptionClick(opt.id)}
                sx={{ borderRadius: 2, display: 'flex', justifyContent: 'space-between' }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Typography sx={{ fontSize: '1.25rem' }}>{opt.icon}</Typography>
                  <ListItemText primary={opt.label} primaryTypographyProps={{ fontWeight: 600 }} />
                </Box>
                <ChevronRightIcon color="action" />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </DialogContent>
    </Dialog>
  );
};
